/**
 * Viko brand: wordmark 54 and its V-only mark, traced from the approved rasters (see
 * docs/ux/artboards/logos/round3/trace). Only the fills are themed: ink follows the text colour
 * and the two streams use the brand blues (`--vk-brand-stream-1/2`, lighter in dark mode as on
 * v-icon-navy.svg). Below 20px the V switches to its 16px optical size, whose streams are merged.
 */
import {
  TRACE_TRANSFORM,
  V_LARGE,
  V_SMALL,
  V_VIEWBOX,
  WORDMARK,
  WORDMARK_ASPECT,
  WORDMARK_VIEWBOX,
} from './brand-paths.js'

type Layers = { inner: string; outer?: string; ink: string }

function Traced({ layers }: { layers: Layers }) {
  return (
    <g transform={TRACE_TRANSFORM}>
      {layers.outer && <path d={layers.outer} fill="var(--vk-brand-stream-2)" />}
      <path d={layers.inner} fill="var(--vk-brand-stream-1)" />
      <path d={layers.ink} fill="currentColor" />
    </g>
  )
}

export function VMark({ size = 24, className }: { size?: number; className?: string }) {
  return (
    <svg
      className={className ? `vmark ${className}` : 'vmark'}
      width={size}
      height={size}
      viewBox={V_VIEWBOX}
      aria-hidden="true"
      focusable="false"
    >
      <Traced layers={size <= 20 ? V_SMALL : V_LARGE} />
    </svg>
  )
}

/** Wordmark 54: `size` is the lowercase letter size, matching the old text-set wordmark. */
export function Wordmark({ size = 22, className }: { size?: number; className?: string }) {
  const height = Math.round(size * 1.3)
  return (
    <svg
      className={className ? `wordmark ${className}` : 'wordmark'}
      width={Math.round(height * WORDMARK_ASPECT)}
      height={height}
      viewBox={WORDMARK_VIEWBOX}
      role="img"
      aria-label="Viko"
    >
      <Traced layers={WORDMARK} />
    </svg>
  )
}
